import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './SearchSectionContainer';
import { KeywordsCarouselWizard } from '../keywords-carousel/KeywordsCarouselWizard';
import { SearchAdviceWizard } from '../search-advice/SearchAdviceWizard';
import { SearchAutoCorrectWizard } from '../auto-correct/SearchAutoCorrectWizard';
import { ZeroResultsRouter } from '../zero-results/ZeroResultsRouter';
import { AsideSearchSnippets } from '../search-snippets/aside/AsideSearchSnippets';
import { SearchResults } from '../search-results/SearchResults';
import { TopLimitation } from '../top-limitation/TopLimitation';
import { SearchFiltersSelected } from '../search-snippets/aside/filter-selected/SearchFiltersSelected';
import { LoaderWithText } from '../../../components/loader/LoaderWithText';
import { SearchHeaderStatus } from './SearchHeaderStatus';
import { SEARCH_TYPES_WITH_FILTERS } from '../../searchContansts';
import { useUser } from '../../../user/useUser';
import styles from './search_section.module.scss';
import { SearchPaginationLoader } from './pagination-loader/SearchPaginationLoader';
import { SearchErrorMessage } from './error/SearchErrorMessage';
import { SearchEndResultsMessage } from './end-results/SearchEndResultsMessage';
import { SearchFiltersSort } from '../search-filters-bar/sort/SearchFiltersSort';
import {
  reportFilterToggle,
  filterActionTypes,
} from '../mobile-actions/filtersUtils';
import { Column } from '../../../components/grid/Grid';

type Props = {
  parentContainerRef?: HTMLDivElement | null;
} & PropsFromRedux;

const RawSearchSection: FC<Props> = ({
  enableAdvice,
  enableSnippets,
  parentContainerRef,
  loaded,
  searchLoading,
  error,
  paginationLoading,
  totalHits,
  hasResults,
  endOfResults,
  type,
  searchTime,
  sortType,
  hits,
  ended,
  needMoreHits,
  exceptExpressions,
}) => {
  const { loggedIn } = useUser();
  const seeAllResultsMessage = hasResults && loaded && endOfResults && loggedIn;
  function track(actionType: filterActionTypes, value: boolean) {
    reportFilterToggle(type, actionType, value);
  }
  return (
    <>
      <Column large={8} medium={12}>
        <div>
          {SEARCH_TYPES_WITH_FILTERS.includes(type) && (
            <SearchFiltersSelected exceptExpressions={exceptExpressions} />
          )}
        </div>
        <div className={styles.headerActions}>
          {!searchLoading && loaded && totalHits > -1 && (
            <SearchHeaderStatus
              searchTime={searchTime}
              totalHits={totalHits}
              type={type}
            />
          )}
          {searchLoading && (
            <LoaderWithText>
              <FormattedMessage id="search/SearchSection.tsx/1" />
            </LoaderWithText>
          )}
          {(type === 'arret' ||
            type === 'commentary' ||
            type === 'preparatory_work') && (
            <SearchFiltersSort
              sortType={sortType}
              track={track}
              searchType={type}
            />
          )}
        </div>

        {enableAdvice && <SearchAdviceWizard />}
        <SearchAutoCorrectWizard />

        {loaded && (
          <>
            <KeywordsCarouselWizard />
            <SearchResults
              loggedIn={loggedIn}
              hits={hits}
              ended={ended}
              type={type}
              isSearchLoading={searchLoading}
              isPaginationLoading={paginationLoading}
              needMoreHits={needMoreHits}
              parentContainerRef={parentContainerRef}
            />
            <TopLimitation />
          </>
        )}

        {paginationLoading && <SearchPaginationLoader />}

        {seeAllResultsMessage && <SearchEndResultsMessage />}

        {error && <SearchErrorMessage error={error} />}

        <ZeroResultsRouter />
      </Column>
      <Column large={4} medium={12}>
        {enableSnippets && <AsideSearchSnippets />}
      </Column>
    </>
  );
};

export const SearchSection = Connect(RawSearchSection);
